import React, {PureComponent, ReactNode} from 'react'
import {RepareoGrayLogoIcon} from '@App/Components/common/Icons'

export type LoaderProps = {
    loaderSizeClass?: string
    logoSizeClass?: string
}

export class Loader extends PureComponent<LoaderProps> {
    render(): ReactNode {
        return (
            <div className="flex justify-center items-center relative">
                <div
                    className={`animate-spin rounded-full ${this.props.loaderSizeClass ? this.props.loaderSizeClass : 'h-32 w-32'} border-b-2 border-primary`}/>
                <div className="absolute">
                    <RepareoGrayLogoIcon
                        className={`${this.props.logoSizeClass ? this.props.logoSizeClass : 'w-14 h-14'}`}/>
                </div>
            </div>
        )
    }
}
